import React from "react";
import { List, Datagrid, TextField, Filter, TextInput } from "react-admin";
import { formatName, parseName } from "../util/misc";

const SchoolFilter = (props) => {
  return (
    <Filter {...props}>
      <TextInput
        label="School Name"
        source="name"
        format={(v) => (v ? formatName(v) : "")}
        parse={(v) => (v ? parseName(v) : "")}
        alwaysOn
      />
    </Filter>
  );
};

const SchoolList = (props) => (
  <List {...props} bulkActionButtons={false} filters={<SchoolFilter />}>
    <Datagrid rowClick="show">
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="abbr" />
      <TextField source="stableId" />
    </Datagrid>
  </List>
);

export default SchoolList;
